'use strict';

const JSZip = require('jszip');
const Alerts = require('lib/alerts');
const AttachmentView = require('./Attachment.js');
const tpl = require('employer/templates/governmentForms/Pcb2FormsMultiple.ejs');
const downloadjs = require('downloadjs');
const loader = require('helpers/loader');
const moment = require('moment');
const axios = require('axios');
const log = require('lib/log')('employer/form-pcb2-multidownload');

const Promise = require('bluebird');

module.exports = Backbone.View.extend({
    itemViews: null,
    employeeIds: [],

    events: {
        'change [type="checkbox"]': 'selectEmployee',
        'click .download-pcb2': 'downloadPcb2',
        'change select#year': 'toggleEmployeeListByYear'
    },

    initialize: function(options) {
        this.itemViews = [];
        this.employeeIds = [];
        this.collapsed = true;

        this.options = _.defaults(options || {}, {
            attachments: null
        });

        this.collection.forEach(employee => {
            this.employeeIds.push(employee.id);
            if (this.options.attachments[employee.id]) {
                this.options.attachments[employee.id].on('reset', () => {
                    this.renderItems(employee, 'reset');
                });
            }
        });
    },

    render: function() {
        this.$el.html(tpl({
            model:      this.model,
            collection: this.collection,
        }));

        _.each(this.itemViews, function(view) {
            view.remove();
        });

        this.itemViews = [];

        if (this.collection.length > 0) {
            this.collection.forEach(this.renderItems.bind(this));
        }

        this.toggleEmployeeListByYear();

        return this;
    },

    renderItems: function(employee, reset) {
        const attachments = this.options.attachments[employee.id];
        const $employee = this.$('.js-employee-' + employee.id);

        if (reset) {
            $employee.html('');
        }

        attachments.forEach(attachment => {
            this.renderItem(attachment, employee);
        });
        if (reset) {
            $employee.fadeIn(200);
        }
    },

    renderItem: function(model, employee) {
        var employeeView = new AttachmentView({model: model});

        this.itemViews.push(employeeView);

        this.$('.js-employee-' + employee.id).append(employeeView.$el);

        return this;
    },

    selectEmployee: function(e) {
        const input = this.$(e.currentTarget);
        const id = input.val();
        const checked = input.prop('checked');

        if (checked === false) {
            const index = this.employeeIds.indexOf(id);
            this.employeeIds.splice(index, 1);
        }
    },

    toggleEmployeeListByYear: function() {
        const year = parseInt(this.$('select#year').val(), 10);
        const employeeIds = [];

        this.collection.forEach(employee => {
            const $targetRow = $(`tr.js-employee-row-${employee.id}`);
            const $targerCheckBox = $targetRow.find('input[type="checkbox"]');
            if (
                moment(employee.get('commencementDate')).year() > year ||
                (
                    employee.get('cessationDate') &&
                    moment(employee.get('cessationDate')).year() < year
                )
            ) {
                $targetRow.addClass('hide');
                $targerCheckBox.prop('checked', false);
            } else {
                $targetRow.removeClass('hide');
                $targerCheckBox.prop('checked', true);
                employeeIds.push(employee.id);
            }
        });

        this.employeeIds = employeeIds;
    },

    downloadPcb2: function(ev) {
        let $button     = this.$(ev.currentTarget);
        let stopLoader  = loader.startFullScreen($button);
        const year = parseInt(this.$('select#year').val(), 10);

        const zip = new JSZip();

        return Promise.each(
            this.collection.filter(
                emp => this.employeeIds.includes(emp.id)
            ),
            employee => employee.generateFormPcb2(year)
                .then(attachment => {
                    const fileName = attachment.get('name')
                        .replace(/[\/]|[\\]/g, '-');
                    return axios.get(attachment.getUrl(), {
                            timeout: 60000,
                            responseType: 'blob'
                        })
                        .then(response => {
                            // check if there is file name duplication as it would overwrite the existing ones.
                            if (zip.file(fileName) !== null) {
                                const numOfDuplicates =
                                    zip.file(new RegExp(fileName)).length;
                                zip.file(
                                    fileName.replace(
                                        /^([^\(\)\.]+).*.pdf$/,
                                        (_,p1) =>
                                            `${p1}(${numOfDuplicates}).pdf`
                                    ),
                                    response.data
                                );
                            } else {
                                zip.file(fileName, response.data);
                            }
                        })
                        .catch(error => {
                            log.error(
                                `Form PCB2 generating failed for employee ${
                                    employee.get('fullName')
                                }`
                            );
                            log.error(error.error);
                        });
                })
        )
        .then(() => zip.generateAsync({type: 'blob'}))
        .then(content => {
            downloadjs(
                content,
                `PCB2(II)-Forms-${year}.zip`,
                'application/zip'
            );
            stopLoader();
        })
        .catch(err => {
            Alerts.show('criticalError', err);
            stopLoader();
        });
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/Pcb2FormsMultiple.js